import {useHasFeature} from "../../hooks/useHasFeature";

const FeatureGuard = ({featureKey, children, fallback = null}) => {
  // check if the requested feature is available in the current license
  const isFeatureEnabled = useHasFeature(featureKey);

  // render children only if the feature is available
  if (isFeatureEnabled) {
    return children;
  }

  // otherwise, render the fallback content or null
  return fallback;
};

export default FeatureGuard;
